import { Platform } from "react-native";

export const isSafari = (): boolean => {
  if (Platform.OS !== "web") return false;

  if (typeof navigator !== "undefined" && navigator.userAgent) {
    return /^((?!chrome|android|crios|fxios).)*safari/i.test(
      navigator.userAgent
    );
  }

  return false;
};
